import * as constants from './constants'

const root = state => state.get('geolocation')

export const isFetchGeolocationPending = (state) => {
  return root(state).get('status') === constants.FETCH_GEOLOCATION_PENDING
}

export const isFetchGeolocationFailure = (state) => {
  return root(state).get('status') === constants.FETCH_GEOLOCATION_FAILURE
}

export const isGeolocationLoaded = (state) => {
  const status = root(state).get('status')
  return (status === constants.FETCH_GEOLOCATION_SUCCESS) || (status === constants.FETCH_GEOLOCATION_FAILURE)
}

export const getIsGdprApplicable = state => root(state).getIn(['data', 'gdprApplicable'])



// WEBPACK FOOTER //
// ./src/scripts/app/modules/geolocation/selectors.js